import React, {useContext, useEffect, useState} from "react";
import {TranslateContext} from "../../context/TranslateContext";
import Translate from "../../components/Translate";
import {Dialog} from 'primereact/dialog';
import {useHistory} from "react-router-dom";
import {
    deleteClasseMacrocategoriaApi,
    downloadTemplateMacrocategorie,
    getClassiMacrocategorieApi
} from "./services/MacrocategorieServices";
import ConfMacrocategorieController from "./components/ConfMacrocategorieController";
import TabellaClassiMacrocategorieController from "./components/TabellaClassiMacrocategorieController";
import ConfClassiMacrocategorieView from "./ConfClassiMacrocategorieView";
import ConfStrutturaClassiMacrocategorieController from "./components/ConfStrutturaClassiMacrocategorieController";
import {STANDARD_ESRS} from "../../utility/common";
import {ParametersContext} from "../../context/ParametersContext";

export default function ConfClassiMacrocategorieController() {

    const [loadingData, setLoadingData] = useState(true);

    const [classiMacrocategorie, setClassiMacrocategorie] = useState([]);
    const [classeMacrocategoriaSel, setClasseMacrocategoriaSel] = useState(null);
    const [showConfirm, setShowConfirm] = useState(false);
    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [keyTab, setKeyTab] = useState(0);
    const [showModalUploadMacr, setShowModalUploadMacr] = useState(false);
    const [showEsrs, setShowEsrs] = useState(false);

    const [showDettagli, setShowDettagli] = useState(false);
    const [elementoDettagli, setElementoDettagli] = useState();

    const {translate} = useContext(TranslateContext);
    const {getParameterValue} = useContext(ParametersContext);
    const history = useHistory();

    async function getEsrs() {
        let standards = await getParameterValue('StandardGestiti');
        setShowEsrs(standards.includes(STANDARD_ESRS));
    }

    async function getClassiMacrocategorie() {
        const response = await getClassiMacrocategorieApi();
        setClassiMacrocategorie(response.data.data);
        setLoadingData(false);
    }

    function setValoriInfo(qualeinfo) {
        let elemento =[];
        if (qualeinfo == 'C') {
            elemento.titolo_dettaglio = translate('titolo classi');
            elemento.testo_dettaglio = translate('testo classi KPI');
        } else if (qualeinfo == 'S') {
            elemento.titolo_dettaglio = translate('titolo struttura');
            elemento.testo_dettaglio = translate('testo struttura KPI');
        } else if (qualeinfo == 'E') {
            elemento.titolo_dettaglio = translate('titolo elementi');
            elemento.testo_dettaglio = translate('testo elementi KPI');
        }
        setElementoDettagli(elemento);
    }

    useEffect(() => {
        getEsrs();
        getClassiMacrocategorie();
    }, []);

    const eliminaClasseMacrocategoria = async () => {
        setShowConfirm(false);
        const response = await deleteClasseMacrocategoriaApi(classeMacrocategoriaSel.id_classe_macrocategoria);
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            setClassiMacrocategorie(response.data.data);
        }
    }

    const downloadTemplate = async () => {
        const response = await downloadTemplateMacrocategorie();
        if (response.data.result === -1) {
            setModalMsg(response.data.description)
            setShow(true)
        } else {
            var a = document.createElement("a");
            a.href = "data:application/vnd.ms-excel;base64," + response.data.data;
            a.download = 'template-import-struttura.xlsx';
            a.click(); //Downloaded file
        }
    }

    function getIconaDettaglio(quale, elemento) {
        return (
            <i
                className="fas fa-info-circle ns-mouse-pointer ps-2"
                style={{
                    fontSize: "1.2rem"
                }}
                onClick={() => {
                    setValoriInfo(quale);
                    setShowDettagli(true);
                }}
            />
        );
    }
    const scrollableTabs = [
        {
            title: <React.Fragment><Translate>Classi</Translate> &nbsp;
                {getIconaDettaglio('C', elementoDettagli)}
            </React.Fragment>,
            content: <TabellaClassiMacrocategorieController
                translate={translate}
                history={history}
                setShowConfirm={setShowConfirm}
                classiMacrocategorie={classiMacrocategorie}
                setClasseMacrocategoriaSel={setClasseMacrocategoriaSel}
            />
        },
        {
            title: <React.Fragment><Translate>Struttura</Translate> &nbsp;
                {getIconaDettaglio('S', elementoDettagli)}
                </React.Fragment>,
            content: <ConfStrutturaClassiMacrocategorieController/>
        },
        {
            title: <React.Fragment><Translate>Elementi</Translate> &nbsp;
                {getIconaDettaglio('E', elementoDettagli)}
            </React.Fragment>,
            content: <ConfMacrocategorieController
                showModalUploadMacr={showModalUploadMacr}
                setShowModalUploadMacr={setShowModalUploadMacr}
            />
        }
    ];

    const bottoniDx = [
        keyTab === 0 && {
            label: translate("Aggiungi"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-classe-macrocategoria");
            }
        },
        keyTab === 1 && {
            label: translate("Aggiungi Struttura"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-struttura-classe-macrocategoria");
            }
        },
        keyTab === 2 && {
            label: translate("Aggiungi"),
            icon: "fas fa-plus-circle",
            command: () => {
                history.push("/upd-macrocategoria");
            }
        },
        keyTab === 2 && showEsrs && {
            label: 'Download template',
            icon: 'fas fa-file-excel',
            command: downloadTemplate
        },
        keyTab === 2 && showEsrs && {
            label: 'Upload oggetti',
            icon: 'fas fa-file-upload',
            command: () => {
                setShowModalUploadMacr(true)
            }
        },
    ];

    return (
        <ConfClassiMacrocategorieView
            keyTab={keyTab}
            modalMsg={modalMsg}
            show={show}
            translate={translate}
            setShowConfirm={setShowConfirm}
            setKey={setKeyTab}
            showConfirm={showConfirm}
            loadingData={loadingData}
            setShow={setShow}
            eliminaClasseMacrocategoria={eliminaClasseMacrocategoria}
            scrollableTabs={scrollableTabs}
            classeMacrocategoriaSel={classeMacrocategoriaSel}
            bottoniDx={bottoniDx}
            elementoDettagli={elementoDettagli}
            showDettagli={showDettagli}
            setShowDettagli={setShowDettagli}
        />
    );
}
